export function validFileSize(value, size=250) {
    if (!value || value.length == 0) {
      return true;
    }

    if (value[0] && value[0].size < size * 1024 * 1024) {
      return true;
    }
    else if(value.size < size * 1024 * 1024){
      return true;
    }

    return false;
  }